import { ProductFeatures } from '@trello/product-features';
import { hasFreeBoardLimitDefined } from './hasFreeBoardLimitDefined';

export const freeBoardsOver = <Team>(team: Team): number => {
  if (
    ProductFeatures.hasProduct(
      (team as { products?: number[] }).products?.[0],
    ) ||
    !hasFreeBoardLimitDefined(team)
  ) {
    return 0;
  }

  const limit = team.limits.orgs.freeBoardsPerOrg;
  if (limit.count === undefined) {
    return 0;
  }

  const delta = limit.disableAt - limit.count;

  return delta < 0 ? Math.abs(delta) : 0;
};
